module.exports = __webpack_public_path__ + "media/styles/images/svg/person-check-green-35d549c4a93f9c7e7fa72c49c694f471.svg";